import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import MenuIcon from "@mui/icons-material/Menu";
import { dot, vosmosLogo2 } from "../assets/img";
import { Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import ProgressiveImage from "rc-progressive-image";

const Header = ({ open, setOpen }) => {
  return (
    <AppBar
      position="fixed"
      color="transparent"
      elevation={0}
      sx={{
        background: "linear-gradient(135deg, #1a0505 0%, #6B0000 35%, #C41E1E 65%, #E82A2A 85%, #FF6B6B 100%)",
        boxShadow: "0 2px 16px rgba(232,42,42,0.40)",
        borderRadius: "0 !important",
      }}
    >
      <Toolbar sx={{ paddingLeft: "16px !important", paddingRight: "16px !important" }}>
        {/* Menu toggle */}
        <Button
          variant=""
          sx={{
            mr: 2,
            p: 0.7,
            minWidth: "auto",
            color: "#fff",
            "&:hover": { background: "rgba(255,255,255,0.15)" },
          }}
          onClick={() => setOpen(!open)}
        >
          <MenuIcon />
        </Button>

        {/* Logo */}
        <Box sx={{ flexGrow: 1 }}>
          <Box className="logo">
            <Link to="/app">
              <ProgressiveImage
                src={vosmosLogo2}
                placeholder={dot}
                errorImage={dot}
                alt="FileHub"
              />
            </Link>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
